import React, { useContext, useEffect } from 'react';
import { PriceCalculationContext } from '../PriceCalculationContext';

import { fetchConditionalProducts } from '../utils/fetchConditionalProducts';
import { Loader } from '../../../molecules/Loader/Loader';
import { formatString } from '../../../assets/js/utils/formatString';
import clsx from 'clsx';

function Conditional() {
    const {
        resourcedTexts,
        productData,
        getConditionalProductsApiUrl,
        conditionalProductsData,
        setConditionalProductsData,
        handleSelectConditionalProduct,
        setActiveStepName,
        selectedOrganizationsIds,
        fixedAmountIsLoadingText,
        conditionalProductsIsLoadingText,
        setConditionalProductsIsLoadingText,
        scrollToTop,
    } = useContext(PriceCalculationContext);
    const fixedAmountIsLoading = Boolean(fixedAmountIsLoadingText);
    const showConditionalProductsLoader = Boolean(conditionalProductsIsLoadingText);

    useEffect(async () => {
        if (!productData || conditionalProductsData) return;

        setConditionalProductsIsLoadingText(resourcedTexts.conditionalProductsLoader);

        try {
            const responseJson = await fetchConditionalProducts(
                getConditionalProductsApiUrl,
                productData.id,
                selectedOrganizationsIds,
                ({ message, percentage }) => {
                    setConditionalProductsIsLoadingText(formatString(message, [percentage]));
                },
            );

            setConditionalProductsIsLoadingText(null);
            scrollToTop();

            if (!responseJson.products || responseJson.products.length <= 0) {
                // No conditional products, so the calculation is finished.
                setActiveStepName('CalculationFinished');
                return;
            }

            setConditionalProductsData(responseJson);
        } catch (error) {
            setConditionalProductsIsLoadingText(null);
            setActiveStepName('CalculationTechnicalProblem');
            console.error('error', error.message);
        }
    }, [productData]);

    return (
        <div className="conditional-products">
            {showConditionalProductsLoader ? (
                <div className="conditional-products__loader-wrapper">
                    <Loader withBackground={false} />
                </div>
            ) : (
                conditionalProductsData?.products.map((product, i) => {
                    const { name, description, productUrl } = product;

                    return (
                        <article className="conditional-products__product" key={i}>
                            <h4 className="conditional-products__name">{name}</h4>

                            {description && (
                                <p className="conditional-products__description">{description}</p>
                            )}

                            <div className="conditional-products__buttons">
                                <a
                                    className={clsx('button secondary', fixedAmountIsLoading && 'disabled')}
                                    href={fixedAmountIsLoading ? null : productUrl}
                                >
                                    <span>{resourcedTexts.viewConditionalProduct}</span>
                                </a>
                                <button
                                    className="button primary"
                                    type="button"
                                    onClick={() => handleSelectConditionalProduct(product)}
                                    disabled={fixedAmountIsLoading}
                                >
                                    <span>{resourcedTexts.selectConditionalProduct}</span>
                                </button>
                            </div>
                        </article>
                    );
                })
            )}
        </div>
    );
}

export { Conditional };
